import { Stack, Typography } from "@mui/material";
import React from "react";

export default function SquishedDate({ date }) {
  let dayAsTwoDigits = date.getDate().toString().padStart(2, "0");
  let monthAsThreeLetters = date.toLocaleString("default", { month: "short" });
  //capitalize all letters
  monthAsThreeLetters = monthAsThreeLetters.toUpperCase();
  return (
    <Stack
      spacing={0}
      style={{
        alignItems: "center",
      }}
    >
      <Typography
        style={{
          lineHeight: 0.8,
        }}
        variant="h5"
      >
        {dayAsTwoDigits}
      </Typography>
      <Typography
        variant="body2"
        style={{
          lineHeight: 0.8,
        }}
      >
        {monthAsThreeLetters}
      </Typography>
    </Stack>
  );
}
